import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { Paths } from '../../constants/paths';
import { useAppContext } from '../../context/AppContext';
import { StorefrontNav } from '../../navigation/components/StorefrontNav';
import { SearchBar } from '../../search-bar/components/SearchBar';
import { ManageBuildDropdowns } from './ManageBuildDropdowns';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function HomepageHeader() {
  const appContext = useAppContext();
  return /*#__PURE__*/_jsx(Flex, {
    blockSize: "140px",
    borderBlockStartWidth: appContext === 'public' ? '100' : '0',
    borderBlockStartStyle: "solid",
    borderBlockStartColor: "border-core-subtle",
    flexDirection: "column",
    justifyContent: "center",
    marginBlockStart: appContext === 'public' ? '300' : '0',
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      backgroundColor: "fill-surface-default",
      "data-test-id": "homepage-header",
      flexDirection: "row",
      insetBlockStart: "0",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsxs(View, {
        children: [/*#__PURE__*/_jsx(UIRouterLink, {
          to: Paths.HOME,
          use: "unstyled",
          children: /*#__PURE__*/_jsx(Text, {
            as: "h1",
            typography: "heading-600",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceStorefront.headers.title"
            })
          })
        }), /*#__PURE__*/_jsx(StorefrontNav, {})]
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "end",
        flexDirection: "column",
        gap: "500",
        inlineSize: "600px",
        marginInline: "300",
        children: [/*#__PURE__*/_jsx(ManageBuildDropdowns, {}), /*#__PURE__*/_jsx(SearchBar, {})]
      })]
    })
  });
}